import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BaseUiModule } from '@mitsubishi/shared/ui';

import { FileInputComponent } from './file-input/file-input.component';

@NgModule({
  declarations: [FileInputComponent],
  imports: [CommonModule, BaseUiModule, ReactiveFormsModule, FormsModule],
  exports: [FileInputComponent],
})
export class UiFileInputModule {}
